import { createUseStyles } from "react-jss";
import frameImage from "../../assets/images/iphone-x.png";
import { shouldUseModernTheme } from "../../theme/navigationButtonThemeColors";

const targetHeight = 728;
const svgWidth = 1307;
const svgHeight = 2600;
const scale = targetHeight / svgHeight;
const hpadding = 48;
const vpadding = 48;
const scaling = 0.8;

export default createUseStyles({
    preview: {
        composes: "preview",
        height: "100%",
        display: "flex",
    },
    previewDesktop: {
        composes: "preview__desktop",
        flex: 1,
        overflowY: "auto",
        position: "relative",
    },
    previewMobile: {
        composes: "preview__mobile",
        background: ({ theme }) => (shouldUseModernTheme(theme) ? theme.PageBackground : "#626262"),
        overflowX: "hidden",
        overflowY: "auto",
        position: "relative",
        display: "flex",
        alignContent: "center",
        width: svgWidth * scale + hpadding * 2,
        paddingTop: vpadding,
        paddingBottom: vpadding,
        paddingLeft: 10,
    },
    deviceFrame: {
        composes: "device-frame",
        width: svgWidth * scale,
        height: svgHeight * scale,
        position: "relative",
        margin: "auto",
    },
    deviceFrameContent: {
        composes: "device-frame__content",
        cursor: "not-allowed",
        position: "absolute",
        top: 200 * scale,
        bottom: 76 * scale,
        left: 84 * scale,
        right: 84 * scale,
        background: ({ theme }) => theme.PageBackground,
        overflow: "hidden",
        overflowY: "auto",
        scrollbarWidth: "none",

        "& .page": {
            pointerEvents: "none",
            userSelect: "none",
            transform: `scale(${scaling})`,
            margin: `${((1 - scaling) / 2) * -100}%`,
            minHeight: "100%",
        },

        "&::-webkit-scrollbar": {
            width: 0,
            height: 0,
        },
    },
    deviceFrameImage: {
        position: "absolute",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        pointerEvents: "none",
        backgroundSize: "contain",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundImage: `url(${frameImage})`,
        zIndex: 9,
    },
    deviceFrameTime: {
        fontFamily: "sans-serif",
        position: "absolute",
        zIndex: 10,
        top: 30,
        left: 44,
        width: 40,
        fontSize: 12,
        background: "white",
        color: "#999",
        fontWeight: 700,
        letterSpacing: "0.06em",
    },
});
